import router from "@/router";
import {TutorialSectionList} from "@/data/classes/tutorial";
import {getValue, goToFireStore} from "@/globalFunctions";
import {MessageBox} from "element-ui";
import i18n from "@/lang";
const tutorialSections = new TutorialSectionList();

export const filters = [
    {
        field: "published",
        clearable: true,
        options: [
            { key: true, label: 'table.published-true' },
            { key: false, label: 'table.published-false' },
        ],
        placeholder: 'table.published'
    },{
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.title-asc', key: 'Title-asc' },
            { label: 'table.order.title-desc', key: 'Title-desc' },
            { label: 'table.order.created-asc', key: 'CreatedDateTime-asc' },
            { label: 'table.order.created-desc', key: 'CreatedDateTime-desc' },
            { label: 'table.order.updated-asc', key: 'DocumentUpdatedDateTime-asc' },
            { label: 'table.order.updated-desc', key: 'DocumentUpdatedDateTime-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.title',
        field: "Title",
    },
    {
        label: 'table.published',
        field: "Published",
        translate: true,
        formatter: (x : any) => {
            return (x ? 'table.published-true' : 'table.published-false');
        },
        tag: true,
        tagType: (x : any) => {
            return (x ? 'success' : 'danger')
        }
    },
    {
        label: 'table.updated',
        field: 'DocumentUpdatedDateTime',
        formatter: (x : any) => {
            return new Date(x).toLocaleString();
        }
    }
];

export const actions = [
    {
        label: 'table.edit',
        icon: "edit",
        type: 'info',
        click: (row : any) => {
            router.push("/admin/tutorials/" + router.currentRoute.params.tutorialId + "/sections/" + row.Id);
        }
    },
    {
        label: 'table.to-firestore',
        icon: "local_fire_department",
        type: 'warning',
        click: (row : any) => {
            goToFireStore({
                type: "tutorial-section",
                tutorialId: router.currentRoute.params.tutorialId,
                tutorialSectionId: row.Id
            });
        }
    },
    {
        label: 'table.delete',
        icon: 'delete',
        type: 'danger',
        click: (row : any) => {
            MessageBox({
                title: i18n.t('confirmations.delete-license.title').toString(),
                message: i18n.t('confirmations.delete-license.text').toString(),
                showCancelButton: true,
                confirmButtonClass: "el-button--info",
                cancelButtonClass: "el-button--danger",
                confirmButtonText: i18n.t('confirmations.default.confirmation-button').toString(),
                cancelButtonText: i18n.t('confirmations.default.cancel-button').toString(),
            }).then(async () => {
                window.GlobalEvents.$emit("start-list-load");
                return tutorialSections.archive(row.Id).then(() => {
                    window.GlobalEvents.$emit("refresh-list");
                })
            });
        }
    }
];

export const getData = async (listQuery : any) => {
    // Get items
    await tutorialSections.get(router.currentRoute.params.tutorialId);
    let items = tutorialSections.toList();

    // Query
    if (listQuery.published === true || listQuery.published === false){
        items = items.filter((x) => x.Published === listQuery.published);
    }

    if (listQuery.language){
        items = items.filter((x) => x.Language === listQuery.language);
    }

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
